import { render, staticRenderFns } from "./MapIconFootballScholl.vue?vue&type=template&id=63681b29&scoped=true&"
import script from "./MapIconFootballScholl.vue?vue&type=script&lang=js&"
export * from "./MapIconFootballScholl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63681b29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63681b29')) {
      api.createRecord('63681b29', component.options)
    } else {
      api.reload('63681b29', component.options)
    }
    module.hot.accept("./MapIconFootballScholl.vue?vue&type=template&id=63681b29&scoped=true&", function () {
      api.rerender('63681b29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconFootballScholl.vue"
export default component.exports